import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { GCADASearchBarComponent } from './search-bar.component';

@NgModule({
    declarations: [
        GCADASearchBarComponent
    ],
    imports     : [
        CommonModule,
        RouterModule,

        MatButtonModule,
        MatIconModule
    ],
    exports     : [
        GCADASearchBarComponent
    ]
})
export class GCADASearchBarModule
{
}
